import { Hint } from '@heathmont/moon-core-tw';

export default Hint;
